import { render } from "./EmpresasAdmin.vue?vue&type=template&id=43669e3b&scoped=true"
import script from "./EmpresasAdmin.vue?vue&type=script&lang=js"
export * from "./EmpresasAdmin.vue?vue&type=script&lang=js"

import "./EmpresasAdmin.vue?vue&type=style&index=0&id=43669e3b&scoped=true&lang=css"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43669e3b"]])

export default __exports__